<template>
  <div class="consult-overlay">
    <!-- 在线咨询  || 咨询医生 -->
    <van-overlay
      class-name="consult-overlay-wapper"
      :show="overlayShow"
      @click="overlayShow = false"
    >
      <div class="consult-overlay" @click.stop>
        <div class="consult-overlay-top">
          <span class="consult-overlay-top-title"> 咨询医生</span>
          <van-icon name="cross" @click="overlayShow = false" />
        </div>
        <div class="consult-overlay-content">
          <div class="consult-overlay-content-title">
            服务介绍
          </div>
          <div class="consult-overlay-content-introduce">
            <span>1. 专科疾病问题随时问医生</span>
            <span>2. 数百位血液肿瘤权威医生在线接诊</span>
            <span>3. 可申请图文/视频1v1交流</span>
            <span>4. 24小时医生不接诊，平台将自动退款</span>
          </div>
        </div>
        <div class="consult-overlay-content">
          <div class="consult-overlay-content-title matter">
            注意事项
          </div>
          <div class="consult-overlay-content-introduce">
            <span>1. 需要上传清晰病历及检查资料</span>
            <span>2. 交流前请准备好具体的疾病问题</span>
            <span>3. 医生百忙中回复，留言后请您耐心等待</span>
            <span>4. 有问题随时联系专属客服</span>
          </div>
        </div>
        <div class="consult-overlay-user-instructions">
          <van-checkbox
            v-model="checked"
            checked-color="#0FB7AD"
            icon-size="16px"
          >
            <div class="consult-overlay-user-instructions-text">
              请阅读并同意 <a href="/#/xy">《用户协议》</a>及<a href="/#/ys"
                >《隐私政策》</a
              >
            </div>
          </van-checkbox>
        </div>

        <div class="consult-overlay-operation">
          <van-button
            @click="onClick"
            type="primary"
            color="#03cbbf"
            block
            round
            >确定</van-button
          >
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Interface from "@/util/interface";
import { LocationHref, isWXmini } from "@/util/common";
import wx from "weixin-js-sdk";
export default {
  props: {
    pageType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      overlayShow: false,
      checked: false
    };
  },
  methods: {
    onClick() {
      if (localStorage.getItem("isMini") == 1) {
        wx.miniProgram.postMessage({
          data: {
            type: "gaobowenzhen" // 消息类型，用于业务逻辑处理
          }
        });
        wx.miniProgram.navigateBack({
          delta: 1
        });
      } else {
        if (!this.checked) {
          this.$toast({
            message: "请先阅读并同意《用户协议》及《个人隐私协",
            className: "toast-overlay"
          });
          return;
        }
        Interface.mFootPrint(
          1,
          82,
          0,
          3,
          0,
          0,
          0,
          "跳转咨询医生服务说明，点击已读并同意的按钮"
        );
        LocationHref(
          "https://byh-api.dr-gobroad.com/wechat-phase/urlLink?name=zixunyisheng&t=" +
            localStorage.getItem("user_id") +
            "&u=" +
            Math.random() * 5
        );
      }
    }
  },
  watch: {
    checked(newVal, oldVal) {
      if (newVal) {
        Interface.mFootPrint(
          1,
          82,
          0,
          this.pageType,
          0,
          0,
          0,
          "医疗服务-咨询医生-用户协议勾选"
        );
      }
    }
  }
};
</script>

<style>
.toast-overlay {
  z-index: 999999999 !important;
}
</style>
<style lang="scss" scoped>
.consult-overlay-wapper {
  z-index: 99999999;

  .consult-overlay {
    position: absolute;
    bottom: 0px;
    background: #fff;
    width: 100%;
    border-radius: 12px 12px 0 0;

    &-top {
      box-sizing: border-box;
      background: url("/static/bytx/ylfw/medical_head_popup_1@3x.png") no-repeat;
      background-size: 100% 100%;
      background-position: 100% 100%;
      height: 100px;
      width: 100%;
      margin-top: -30px;
      padding-top: 40px;
      text-align: center;
      position: relative;
      .van-icon {
        position: absolute;
        right: 15px;
        top: 40px;
        font-size: 18px;
        width: 30px;
        height: 30px;
      }

      &-title {
        margin-top: 10px;
        display: inline-block;
        font-size: 18px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #282828;
      }
    }

    &-content {
      margin: 0px 20px;
      &-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #282828;
      }

      &-introduce {
        padding-top: 14px;
        display: flex;
        flex-direction: column;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #777777;

        span {
          padding-bottom: 10px;
        }
      }

      .matter {
        margin-top: 10px;
      }
    }

    &-user-instructions {
      margin: 0px 20px;
      margin-top: 14px;
      margin-bottom: 16px;

      &-text {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #777777;
        display: flex;
        align-items: center;
      }

      a {
        color: #0cc4b9ff;
      }
    }

    &-operation {
      margin: 0px 20px auto;

      .van-button {
        width: 335px;
        height: 42px;
        border-radius: 22px;
        margin-bottom: 36px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/overlay/consult.vue